import PropTypes from "prop-types";

import componentType from "./react.proptypes";

const connectedComponentType = PropTypes.shape({
  WrappedComponent: componentType,
  displayName: PropTypes.string,
  type: PropTypes.func,
});

export default connectedComponentType;
